import { __assign } from 'tslib';
import { isNull, throwError as throwError$1, isArray, isUndefined } from 'intact-shared';
import { getTypeForVNodeElement } from 'misstime';

function trimRight(str) {
    var index = str.length;
    while (index-- && isWhiteSpace(str.charCodeAt(index))) { }
    return str.slice(0, index + 1);
}
function isWhiteSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) ||
        charCode == 32 ||
        charCode == 160) ||
        charCode == 5760 ||
        charCode == 6158 ||
        (charCode >= 8192 &&
            (charCode <= 8202 ||
                charCode == 8232 ||
                charCode == 8233 ||
                charCode == 8239 ||
                charCode == 8287 ||
                charCode == 12288 ||
                charCode == 65279)));
}
var selfClosingTags = {
    'area': true,
    'base': true,
    'br': true,
    'col': true,
    'command': true,
    'embed': true,
    'hr': true,
    'img': true,
    'input': true,
    'keygen': true,
    'link': true,
    'menuitem': true,
    'meta': true,
    'param': true,
    'source': true,
    'track': true,
    'wbr': true
};
var textTags = {
    style: true,
    script: true,
    textarea: true
};
var directivesMap = {
    /* don't use Directives, because of tree-shaking and performance */
    'v-if': true,
    'v-else-if': true,
    'v-else': true,
    'v-for': true,
    'v-for-value': true,
    'v-for-key': true,
    'v-raw': true,
    // [Directives.If]: true,
    // [Directives.ElseIf]: true,
    // [Directives.Else]: true,
    // [Directives.For]: true,
    // [Directives.ForValue]: true,
    // [Directives.ForKey]: true,
    // // [Directives.Model]: true,
    // [Directives.Raw]: true,
};
function isJSIdentifierPart(ch) {
    return (ch === 95) || ch === 36 || // _ (underscore) $
        (ch >= 65 && ch <= 90) || // A..Z
        (ch >= 97 && ch <= 122) || // a..z
        (ch >= 48 && ch <= 57); // 0..9
}
function isJSXIdentifierPart(ch) {
    return (ch === 58) || (ch === 45) || ch === 46 || isJSIdentifierPart(ch); // : - .
}
function isWhiteSpaceExceptLinebreak(charCode) {
    return charCode !== 10 && // \n
        charCode !== 13 && // \r
        isWhiteSpace(charCode);
}
function isElementNode(node) {
    var type = node.type;
    return type === 3 /* JSXCommonElement */ ||
        type === 4 /* JSXComponent */ ||
        type === 6 /* JSXVdt */ ||
        type === 7 /* JSXBlock */;
}
function throwError(msg, loc, source) {
    var lines = source.split('\n');
    var line = loc.line, column = loc.column;
    var error = new Error("".concat(msg, " (").concat(line, ":").concat(column, ")\n") +
        "> ".concat(line, " | ").concat(lines[line - 1], "\n") +
        "  ".concat(new Array(String(line).length + 1).join(' '), " | ").concat(new Array(column).join(' '), "^"));
    throw error;
}
var attrMaps = {
    'class': 'className',
    'for': 'htmlFor'
};
var getAttrName = function (name) {
    return attrMaps[name] || name;
};
var defaultOptions = {
    delimiters: ['{', '}'],
};
function computeChildrenFlagForVIf(lastFlag, nextFlag) {
    if (lastFlag === 0 /* UnknownChildren */)
        return lastFlag;
    if (lastFlag === 2 /* HasKeyedVNodeChildren */ &&
        nextFlag === 4 /* HasNonKeyedVNodeChildren */) {
        return nextFlag;
    }
    return lastFlag & nextFlag;
}
function computeChildrenFlagForChildren(lastFlag, nextFlag) {
    if (isNull(lastFlag))
        return nextFlag;
    // two array children is unknown children
    if (lastFlag === nextFlag && (lastFlag & 24 /* MultipleChildren */)) {
        return 0 /* UnknownChildren */;
    }
    return lastFlag & nextFlag;
}
function childrenFlagToChildrenType(flag) {
    if (process.env.NODE_ENV !== 'production') {
        switch (flag) {
            case 0 /* UnknownChildren */:
                return "".concat(0 /* UnknownChildren */, " /* UnknownChildren */");
            case 1 /* HasInvalidChildren */:
                return "".concat(1 /* HasInvalidChildren */, " /* HasInvalidChildren */");
            case 2 /* HasKeyedVNodeChildren */:
            case 4 /* HasNonKeyedVNodeChildren */:
                return "".concat(2 /* HasVNodeChildren */, " /* HasVNodeChildren */");
            case 8 /* HasKeyedChildren */:
                return "".concat(8 /* HasKeyedChildren */, " /* HasKeyedChildren */");
            case 16 /* HasNonKeyedChildren */:
                return "".concat(4 /* HasNonKeyedChildren */, " /* HasNonKeyedChildren */");
            case 32 /* HasTextChildren */:
                return "".concat(16 /* HasTextChildren */, " /* HasTextChildren */");
            /* istanbul ignore next */
            default:
                throwError$1('Unknown flag: ' + flag);
        }
    }
    else {
        /* istanbul ignore next */
        switch (flag) {
            case 0 /* UnknownChildren */:
                return 0 /* UnknownChildren */;
            case 1 /* HasInvalidChildren */:
                return 1 /* HasInvalidChildren */;
            case 2 /* HasKeyedVNodeChildren */:
            case 4 /* HasNonKeyedVNodeChildren */:
                return 2 /* HasVNodeChildren */;
            case 8 /* HasKeyedChildren */:
                return 8 /* HasKeyedChildren */;
            case 16 /* HasNonKeyedChildren */:
                return 4 /* HasNonKeyedChildren */;
            case 32 /* HasTextChildren */:
                return 16 /* HasTextChildren */;
            default:
                throwError$1('Unknown flag: ' + flag);
        }
    }
}
var helpersMap = {
    '_$cv': 'createVNode',
    '_$ce': 'createElementVNode',
    '_$cc': 'createUnknownComponentVNode',
    '_$ct': 'createTextVNode',
    '_$ccv': 'createCommentVNode',
    '_$cu': 'createUnescapeTextVNode',
    '_$le': 'linkEvent',
    '_$ma': 'map',
    '_$ex': 'extend',
    '_$stm': 'setTextModel',
    '_$srm': 'setRadioModel',
    '_$scm': 'setCheckboxModel',
    '_$ssm': 'setSelectModel',
    '_$isc': 'isChecked',
    '_$cn': 'className',
    '_$su': 'superCall',
    '_$no': 'noop',
    '_$em': 'EMPTY_OBJ',
    // '_$tr': 'Transtion',
    // '_$tg': 'TransitionGroup',
};

function validateDirectiveValue(name, valueType, tag, tagType, source, loc) {
    if (name === "v-raw" /* Raw */) {
        if (tagType !== 3 /* JSXCommonElement */) {
            throwError("Only html elememt supports v-raw, but got: ".concat(tag), { line: loc.line, column: loc.column - "v-raw" /* Raw */.length }, source);
        }
    }
    else if (name === "v-for-key" /* ForKey */ || name === "v-for-value" /* ForValue */) {
        if (valueType !== 12 /* JSXString */) {
            throwError("'".concat(name, "' must be a literal string."), loc, source);
        }
    }
    else if (name === "v-for" /* For */ || name === "v-if" /* If */ || name === "v-else-if" /* ElseIf */) {
        if (valueType !== 8 /* JSXExpression */) {
            throwError("'".concat(name, "' must be a expression."), loc, source);
        }
    }
    else if (name === "v-else" /* Else */) {
        if (valueType !== 14 /* JSXNone */) {
            throwError("'".concat(name, "' should not have value."), loc, source);
        }
    }
}
function validateModel(tag, type, attributes, source) {
    var find = function (name) {
        return attributes.find(function (attr) { return attr.type === 11 /* JSXAttribute */ && attr.name === name; });
    };
    var model = find('v-model');
    if (!model)
        return;
    var loc = model.loc;
    if (type === 3 /* JSXCommonElement */ && tag !== 'input' && tag !== 'textarea' && tag !== 'select') {
        throwError("Only form element and component support 'v-model'", loc, source);
    }
    if (tag === 'input') {
        var typeAttr = find('type');
        if (typeAttr && typeAttr.value.type !== 12 /* JSXString */) {
            throwError("If use 'v-model' on 'input' element, " +
                "the 'type' property of element cannot be dynamic value.", typeAttr.value.loc, source);
        }
    }
}
function validateAttributeForBlock(tag, name, value, loc, source) {
    switch (name) {
        case "v-if" /* If */:
        case "v-else-if" /* ElseIf */:
        case "v-else" /* Else */:
        case "v-for" /* For */:
        case "v-for-key" /* ForKey */:
        case "v-for-value" /* ForValue */:
            break;
        case 'args':
            if (value.type !== 12 /* JSXString */) {
                throwError("The 'args' attribute of block element '<b:".concat(tag, ">' must be a literal string."), loc, source);
            }
            break;
        case 'params':
            if (value.type !== 8 /* JSXExpression */) {
                throwError("The 'params' attribute of block element '<b:".concat(tag, ">' must be a expression that value is an array."), loc, source);
            }
            break;
        default:
            throwError("Block element '<b:".concat(tag, ">' does not support the attribute '").concat(name, "'."), loc, source);
    }
}

var tagNameRegexp = /^<\w+:?\s*[\{\w\/>]/;
var Parser = /*#__PURE__*/ /*#__PURE__*/ /** @class */ (function () {
    function Parser(source, options) {
        this.index = 0;
        this.line = 1;
        this.column = 1;
        this.options = defaultOptions;
        this.source = trimRight(source);
        this.length = this.source.length;
        if (options) {
            this.options = __assign(__assign({}, defaultOptions), options);
        }
        this.ast = this.parse(true, 0);
    }
    Parser.prototype.parse = function (isRoot, spaces) {
        var nodes = [];
        var braces = { count: 0 };
        while (this.index < this.length && braces.count >= 0) {
            nodes.push(this.advance(braces, isRoot, spaces));
        }
        return nodes;
    };
    Parser.prototype.advance = function (braces, isRoot, spaces) {
        var ch = this.char();
        if (isRoot && this.isJSImport()) {
            return this.scanJSImport();
        }
        if (ch !== '<') {
            return this.scanJS(braces, isRoot, spaces);
        }
        return this.scanJSX();
    };
    Parser.prototype.scanJSImport = function () {
        var start = this.index;
        var loc = this.getLocation();
        this.updateIndex(7); // 'import '.length
        while (this.index < this.length) {
            var ch = this.char();
            if (ch === '\'' || ch === '"') {
                this.scanString();
                var start_1 = void 0;
                do {
                    start_1 = this.index;
                    this.skipWhitespaceAndJSComment();
                    if (this.char() === ';') {
                        this.updateIndex();
                    }
                } while (start_1 !== this.index);
                break;
            }
            else {
                this.updateIndex();
            }
        }
        return { type: 1 /* JSHoist */, value: this.getValue(start), loc: loc };
    };
    Parser.prototype.scanJS = function (braces, isRoot, spaces) {
        var delimiters = this.options.delimiters;
        var loc = this.getLocation();
        var value = [];
        var start = this.index;
        var spacesRemain = spaces;
        var newLine = true;
        var leadSpaces = 0;
        var shouldTrimRight = false;
        while (this.index < this.length) {
            this.skipJSComment();
            var ch = this.char();
            var tmp = void 0;
            if (ch === '\'' || ch === '"' || ch === '`' ||
                // is a RegExp, treat it as literal sting
                ch === '/' &&
                    // is not /* and //, this is comment
                    (tmp = this.char(this.index + 1)) && tmp !== '*' && tmp !== '/' && (
                // is the first char
                this.index === 0 ||
                    // is not </, this is a end tag
                    (tmp = this.char(this.index - 1)) && tmp !== '<' &&
                        // is not a division sign
                        // FIXME: expect `if (a > 1) /test/`
                        (tmp = this.getLastCharCode()) && !isJSIdentifierPart(tmp) && tmp !== 41 // )
                )) {
                // skip tag(<div>) in quotes
                this.scanString();
                newLine = false;
                continue;
            }
            else if (this.isTagStart()) {
                break;
            }
            else if (isRoot && this.isJSImport()) {
                break;
            }
            else if (ch === '\n') {
                value.push(this.getValue(start));
                start = this.index + 1;
                spacesRemain = spaces;
                newLine = true;
                leadSpaces = 0;
                this.updateLine();
            }
            else if (newLine && ch === ' ') {
                if (spacesRemain) {
                    spacesRemain--;
                    start++;
                }
                else {
                    leadSpaces++;
                }
            }
            else {
                if (ch === '{') {
                    braces.count++;
                }
                else if (braces.count > 0 && ch === '}') {
                    braces.count--;
                }
                else if (this.isExpect(delimiters[1])) {
                    // for parse break
                    braces.count--;
                    shouldTrimRight = true;
                    break;
                }
                newLine = false;
            }
            this.updateIndex();
        }
        value.push(this.getValue(start));
        if (shouldTrimRight) {
            this.trimRightForValue(value);
        }
        return { type: 0 /* JS */, value: value, spaces: leadSpaces, loc: loc };
    };
    Parser.prototype.scanJSX = function () {
        this.expect('<');
        if (this.isExpect('!--')) {
            // is html comment
            return this.parseJSXComment();
        }
        return this.parseJSXElement();
    };
    Parser.prototype.scanString = function () {
        var loc = this.getLocation();
        var str = '';
        var quote = this.char();
        this.updateIndex();
        this.index;
        while (this.index < this.length) {
            var ch = this.char();
            if (ch.charCodeAt(0) === 10) {
                this.updateLine();
            }
            this.updateIndex();
            if (ch === quote) {
                quote = '';
                break;
            }
            else if (ch === '\\') {
                str += this.char(this.updateIndex());
            }
            else {
                str += ch;
            }
        }
        if (quote !== '') {
            this.error('Unclosed quote', loc);
        }
        return { type: 12 /* JSXString */, value: str, loc: loc };
    };
    Parser.prototype.parseJSXElement = function () {
        var flag = this.charCode();
        var loc = this.getLocation();
        var start = this.index;
        var type;
        if (flag >= 65 && flag <= 90 /* upper case */) {
            // is a component 
            type = 4 /* JSXComponent */;
        }
        else if (this.charCode(this.index + 1) === 58 /* : */) {
            // is a directive
            start += 2;
            switch (flag) {
                case 116: // t
                    type = 6 /* JSXVdt */;
                    break;
                case 98: // b
                    type = 7 /* JSXBlock */;
                    break;
                /* istanbul ignore next */
                default:
                    this.error('Unknown directive ' + String.fromCharCode(flag) + ':');
            }
            this.updateIndex(2);
        }
        else {
            // is an element
            type = 3 /* JSXCommonElement */;
        }
        while (this.index < this.length) {
            if (!isJSXIdentifierPart(this.charCode())) {
                break;
            }
            this.updateIndex();
        }
        var value = this.getValue(start);
        var _a = this.parseJSXAttribute(value, type), attributes = _a.attributes, directives = _a.directives, keyed = _a.keyed, hasVRaw = _a.hasVRaw;
        var children = this.parseJSXChildren(value, type, attributes, hasVRaw, loc);
        if (process.env.NODE_ENV !== 'production') {
            validateModel(value, type, attributes, this.source);
        }
        return { type: type, value: value, attributes: attributes, directives: directives, children: children, keyed: keyed, loc: loc };
    };
    Parser.prototype.parseJSXComment = function () {
        this.expect('!--');
        var start = this.index;
        var loc = this.getLocation();
        while (this.index < this.length) {
            if (this.isExpect('-->')) {
                break;
            }
            else if (this.charCode() === 10) {
                this.updateLine();
            }
            this.updateIndex();
        }
        var value = this.getValue(start);
        this.expect('-->');
        return { type: 5 /* JSXComment */, value: value, loc: loc };
    };
    Parser.prototype.parseJSXAttribute = function (tag, type) {
        var attributes = [];
        var directives = {};
        var keyed = false;
        var hasVRaw = false;
        var value;
        while (this.index < this.length) {
            this.skipWhitespace();
            if (this.char() === '/' || this.char() === '>') {
                break;
            }
            var delimiters = this.options.delimiters;
            if (this.isExpect(delimiters[0])) {
                // support dynamic attributes
                var expression = this.parseJSXExpression();
                if (expression.value.length) {
                    // ignore empty expression
                    attributes.push(expression);
                }
                continue;
            }
            var loc = this.getLocation();
            var name_1 = this.parseJSXAttributeName();
            if (!keyed && name_1 === 'key') {
                keyed = true;
            }
            if (this.char() === '=') {
                this.updateIndex();
                value = this.parseJSXAttributeValue();
            }
            else {
                // treat no-value attribute as true
                value = {
                    type: 14 /* JSXNone */,
                    loc: this.getLocation(),
                };
            }
            if (process.env.NODE_ENV !== 'produdction') {
                if (directivesMap[name_1]) {
                    validateDirectiveValue(name_1, value.type, tag, type, this.source, value.loc);
                }
                if (type === 7 /* JSXBlock */) {
                    validateAttributeForBlock(tag, name_1, value, value.loc, this.source);
                }
            }
            if (name_1 === "v-if" /* If */ || name_1 === "v-else-if" /* ElseIf */ || name_1 === "v-else" /* Else */) {
                directives[name_1] = { type: 9 /* JSXDirectiveIf */, name: name_1, value: value, next: null, loc: loc };
            }
            else {
                var attr = { type: 11 /* JSXAttribute */, name: name_1, value: value, loc: loc };
                if (directivesMap[name_1]) {
                    if (name_1 === "v-raw" /* Raw */) {
                        hasVRaw = true;
                    }
                    directives[name_1] = attr;
                }
                else {
                    attributes.push(attr);
                }
            }
        }
        return { attributes: attributes, directives: directives, keyed: keyed, hasVRaw: hasVRaw };
    };
    Parser.prototype.parseJSXAttributeName = function () {
        if (process.env.NODE_ENV !== 'production') {
            if (!isJSXIdentifierPart(this.charCode())) {
                this.error('Unexpected identifier ' + this.char());
            }
        }
        var start = this.index;
        while (this.index < this.length) {
            var ch = this.charCode();
            if (!isJSXIdentifierPart(ch)) {
                break;
            }
            this.updateIndex();
        }
        return this.getValue(start);
    };
    Parser.prototype.parseJSXAttributeValue = function () {
        var delimiters = this.options.delimiters;
        var value;
        if (this.isExpect(delimiters[0])) {
            value = this.parseJSXExpression();
        }
        else {
            var quote = this.char();
            if (quote !== '\'' && quote !== '"' && quote !== '`') {
                this.error('String value of attribute must start with a quote.');
            }
            value = this.scanString();
        }
        return value;
    };
    Parser.prototype.parseJSXChildren = function (tag, type, attributes, hasVRaw, loc) {
        var children = [];
        if (type === 3 /* JSXCommonElement */ && selfClosingTags[tag]) {
            // self closing tag
            if (this.char() === '/') {
                this.updateIndex();
            }
            this.expect('>');
        }
        else if (this.char() === '/') {
            // unknown self closing tag
            this.updateIndex();
            this.expect('>');
        }
        else {
            this.expect('>');
            if (textTags[tag]) {
                // if it is a text element, treat children as innerHTML attribute
                var attrLoc = this.getLocation();
                var children_1 = this.parseJSXChildrenValue(tag, type, hasVRaw, true, loc);
                if (children_1.length) {
                    attributes.push({
                        type: 11 /* JSXAttribute */,
                        name: tag === 'textarea' ? 'value' : 'innerHTML',
                        value: {
                            type: 13 /* JSXStrings */,
                            value: children_1,
                            loc: attrLoc,
                        },
                        loc: loc,
                    });
                }
            }
            else {
                children = this.parseJSXChildrenValue(tag, type, hasVRaw, false, loc);
            }
        }
        return children;
    };
    Parser.prototype.parseJSXChildrenValue = function (tag, type, hasVRaw, isTextTag, loc) {
        var children = [];
        var endTag = tag + '>';
        switch (type) {
            case 7 /* JSXBlock */:
                endTag = '</b:' + endTag;
                break;
            case 6 /* JSXVdt */:
                endTag = '</t:' + endTag;
                break;
            default:
                endTag = '</' + endTag;
                break;
        }
        if (hasVRaw) {
            while (this.index < this.length) {
                if (this.isExpect(endTag)) {
                    break;
                }
                children.push(this.scanJSXText([endTag]));
            }
        }
        else {
            this.skipWhitespaceBetweenTags(endTag);
            var directiveIf = null;
            while (this.index < this.length) {
                if (this.isExpect(endTag)) {
                    break;
                }
                var child = this.parseJSXChild(endTag, isTextTag);
                if (isElementNode(child)) {
                    var directives = child.directives;
                    var tmp = void 0;
                    var isElse = false;
                    if (tmp = directives["v-if" /* If */]) {
                        directiveIf = tmp;
                    }
                    else if ((tmp = directives["v-else-if" /* ElseIf */]) ||
                        (tmp = directives["v-else" /* Else */]) && (isElse = true)) {
                        if (process.env.NODE_ENV !== 'production') {
                            if (!directiveIf) {
                                throwError("'".concat(tmp.name, "' must be lead with 'v-if' or 'v-else-if'"), child.loc, this.source);
                            }
                        }
                        directiveIf.next = child;
                        directiveIf = isElse ? null : tmp;
                        continue;
                    }
                }
                children.push(child);
            }
        }
        this.parseJSXClosingTag(endTag, loc);
        return children;
    };
    Parser.prototype.parseJSXChild = function (endTag, isTextTag) {
        var _this = this;
        var delimiters = this.options.delimiters;
        var child;
        if (this.isExpect(delimiters[0])) {
            child = this.parseJSXExpression();
            this.skipWhitespaceBetweenTags(endTag, false);
        }
        else if (isTextTag) {
            child = this.scanJSXText([endTag, delimiters[0]]);
        }
        else if (this.isTagStart()) {
            child = this.scanJSX();
            this.skipWhitespaceBetweenTags(endTag);
        }
        else {
            child = this.scanJSXText([function () {
                    return _this.isExpect(endTag) || _this.isTagStart();
                }, delimiters[0]]);
        }
        return child;
    };
    Parser.prototype.parseJSXClosingTag = function (endTag, loc) {
        this.expect('</', "Unclosed tag: ".concat(endTag), loc);
        while (this.index < this.length) {
            if (!isJSXIdentifierPart(this.charCode())) {
                break;
            }
            this.updateIndex();
        }
        this.skipWhitespace();
        this.expect('>');
    };
    Parser.prototype.scanJSXText = function (stopChars) {
        var start = this.index;
        var l = stopChars.length;
        var loc = this.getLocation();
        var i;
        var charCode;
        loop: while (this.index < this.length) {
            charCode = this.charCode();
            if (isWhiteSpace(charCode)) {
                if (charCode === 10) {
                    this.updateLine();
                }
            }
            else {
                for (i = 0; i < l; i++) {
                    var stopChar = stopChars[i];
                    if (typeof stopChar === 'function' && stopChar() ||
                        this.isExpect(stopChar)) {
                        break loop;
                    }
                }
            }
            this.updateIndex();
        }
        return { type: 2 /* JSXText */, value: this.getValue(start), loc: loc };
    };
    Parser.prototype.parseJSXExpression = function () {
        var delimiters = this.options.delimiters;
        var loc = this.getLocation();
        this.expect(delimiters[0]);
        this.skipWhitespaceAndJSComment();
        var spaceColumn = this.getFirstSpaceColumn();
        var type = 8 /* JSXExpression */;
        var value;
        if (this.isExpect('=')) {
            // if the lead char is '=', then treat it as unescape string
            this.expect('=');
            this.skipWhitespace();
            type = 10 /* JSXUnescapeText */;
        }
        if (this.isExpect(delimiters[1])) {
            value = [];
        }
        else {
            value = this.parse(false, spaceColumn);
        }
        this.expect(delimiters[1], "Unclosed delimiter", loc);
        return { type: type, value: value, loc: loc };
    };
    Parser.prototype.getLocation = function () {
        return { line: this.line, column: this.column };
    };
    Parser.prototype.getValue = function (start, index) {
        if (index === void 0) { index = this.index; }
        return this.source.slice(start, index);
    };
    Parser.prototype.char = function (index) {
        if (index === void 0) { index = this.index; }
        return this.source.charAt(index);
    };
    Parser.prototype.charCode = function (index) {
        if (index === void 0) { index = this.index; }
        return this.source.charCodeAt(index);
    };
    Parser.prototype.isJSImport = function () {
        return this.isExpect('import ');
    };
    Parser.prototype.isExpect = function (expect, index) {
        if (index === void 0) { index = this.index; }
        return this.source.slice(index, index + expect.length) === expect;
    };
    Parser.prototype.updateIndex = function (index) {
        if (index === void 0) { index = 1; }
        var oldIndex = this.index;
        this.index = oldIndex + index;
        this.column += index;
        return oldIndex;
    };
    Parser.prototype.updateLine = function () {
        this.line++;
        this.column = 0;
    };
    Parser.prototype.error = function (msg, loc) {
        throwError(msg, loc || { line: this.line, column: this.column }, this.source);
    };
    Parser.prototype.skipWhitespaceAndJSComment = function () {
        var start;
        do {
            start = this.index;
            this.skipWhitespace();
            this.skipJSComment();
        } while (start !== this.index);
    };
    Parser.prototype.skipJSComment = function () {
        var start;
        do {
            start = this.index;
            if (this.char() === '/') {
                var ch = this.char(this.index + 1);
                if (ch === '/') {
                    this.updateIndex(2);
                    while (this.index < this.length) {
                        var code = this.charCode();
                        if (code === 10) {
                            // is \n
                            break;
                        }
                        this.updateIndex();
                    }
                }
                else if (ch === '*') {
                    this.updateIndex(2);
                    while (this.index < this.length) {
                        if (this.isExpect('*/')) {
                            this.updateIndex(2);
                            break;
                        }
                        else if (this.charCode() === 10) {
                            this.updateLine();
                        }
                        this.updateIndex();
                    }
                }
            }
        } while (start !== this.index);
    };
    Parser.prototype.getLastCharCode = function () {
        var start = this.index - 1;
        var _start;
        do {
            _start = start;
            while (start >= 0) {
                var code = this.charCode(start);
                if (!isWhiteSpaceExceptLinebreak(code)) {
                    break;
                }
                start--;
            }
            // only check multi-line comments '/* comment */'
            while (start >= 0) {
                if (this.char(start) === '/' && this.char(start - 1) === '*') {
                    start -= 2;
                    while (start >= 0) {
                        if (this.char(start) === '*' && this.char(start - 1) === '/') {
                            start -= 2;
                            break;
                        }
                        start--;
                    }
                }
                break;
            }
        } while (start !== _start);
        return this.charCode(start);
    };
    Parser.prototype.getFirstSpaceColumn = function () {
        var start = this.index - 1;
        var hasSet = false;
        var _start;
        do {
            var ch = this.char(start);
            if (ch === '\n' || start === 0) {
                if (!hasSet)
                    _start = start;
                break;
            }
            if (ch === ' ') {
                if (!hasSet) {
                    _start = start;
                    hasSet = true;
                }
            }
            else {
                hasSet = false;
            }
            start--;
        } while (true);
        return this.column - (this.index - _start);
    };
    Parser.prototype.isTagStart = function (index) {
        if (index === void 0) { index = this.index; }
        return this.char(index) === '<' &&
            (this.isExpect('<!--', index) ||
                tagNameRegexp.test(this.source.slice(index)));
    };
    Parser.prototype.expect = function (str, msg, loc) {
        if (!this.isExpect(str)) {
            this.error(msg || 'Expect string ' + str, loc);
        }
        this.updateIndex(str.length);
    };
    Parser.prototype.skipWhitespace = function () {
        while (this.index < this.length) {
            var code = this.charCode();
            if (!isWhiteSpace(code)) {
                break;
            }
            else if (code === 10) {
                // is \n
                this.updateLine();
            }
            this.updateIndex();
        }
    };
    Parser.prototype.skipWhitespaceBetweenTags = function (endTag, skipBeforeDelimiter) {
        if (skipBeforeDelimiter === void 0) { skipBeforeDelimiter = true; }
        var delimiters = this.options.delimiters;
        var start = this.index;
        while (start < this.length) {
            var code = this.charCode(start);
            if (isWhiteSpace(code)) {
                start++;
            }
            else if (this.isExpect(endTag, start) ||
                this.isTagStart(start) ||
                // skip whitespaces between tag starting and expression
                // but not skip before tag ending 
                (skipBeforeDelimiter && this.isExpect(delimiters[0], start))) {
                this.skipWhitespace();
                break;
            }
            else {
                break;
            }
        }
    };
    Parser.prototype.trimRightForValue = function (value) {
        for (var i = value.length - 1; i >= 0; i--) {
            var code = value[i];
            var lastIndex = code.length - 1;
            var j = lastIndex;
            for (; j >= 0; j--) {
                var charCode = code.charCodeAt(j);
                if (!isWhiteSpace(charCode)) {
                    break;
                }
            }
            if (j === -1) {
                // remove the whole line code
                value.pop();
            }
            else {
                if (j !== lastIndex) {
                    // trim right
                    value[i] = code.slice(0, j + 1);
                }
                break;
            }
        }
    };
    return Parser;
}());

var fakeLoc = { line: 0, column: 0 };
var numberRegExp = /^\d+$/;
var Visitor = /*#__PURE__*/ /*#__PURE__*/ /** @class */ (function () {
    function Visitor(nodes) {
        this.enterStringExpression = false;
        this.hoist = [];
        this.queue = [];
        this.queueStack = [this.queue];
        this.current = this.queue;
        this.line = 1;
        this.column = 0;
        this.indentLevel = 0;
        this.spaces = '';
        this.spacesStatck = [''];
        this.expressionSpacesStack = [];
        this.helpers = {};
        this.declares = {};
        this.tmpIndex = 0;
        this.hoistDeclares = [];
        this.functionHead = this.pushQueue();
        this.append("function($props, $blocks, $__proto__) {");
        this.indent();
        this.append("$blocks || ($blocks = {});");
        this.newline();
        this.append("$props || ($props = {});");
        this.newline();
        this.append('var $this = this;');
        this.popQueue();
        this.newline();
        this.visit(nodes, true);
        this.append(';');
        this.dedent();
        this.append('};');
    }
    Visitor.prototype.getCode = function () {
        var helpers = [];
        for (var key in this.helpers) {
            helpers.push("var ".concat(key, " = Vdt.").concat(helpersMap[key], ";\n"));
        }
        return [
            this.hoist.join(''),
            "var Vdt = _$vdt;\n",
            helpers.join(''),
            this.getHositDeclares(),
            "\nreturn ",
            this.functionHead.join(''),
            this.getDelares(),
            this.queue.join(''),
        ].join('');
    };
    Visitor.prototype.getModuleCode = function (moduleName) {
        if (moduleName === void 0) { moduleName = 'vdt/runtime'; }
        var helpers = this.pushQueue();
        var keys = Object.keys(this.helpers);
        var length = keys.length;
        if (length) {
            helpers.push("import {");
            this.indent();
            for (var i = 0; i < length; i++) {
                var key = keys[i];
                helpers.push("".concat(helpersMap[key], " as ").concat(key, ","));
                if (i !== length - 1) {
                    this.newline();
                }
            }
            this.dedent();
            this.append("} from '".concat(moduleName, "';\n"));
        }
        this.popQueue();
        return [
            helpers.join(''),
            this.hoist.join(''),
            this.getHositDeclares(),
            '\nexport default ',
            this.functionHead.join(''),
            this.getDelares(),
            this.queue.join(''),
        ].join('');
    };
    Visitor.prototype.getDelares = function () {
        var declares = this.pushQueue();
        this.indent();
        for (var key in this.declares) {
            var declare = this.declares[key];
            this.append("var ".concat(key, " = "));
            this.append(isArray(declare) ? declare.join('') : declare);
            this.append(';');
            this.newline();
        }
        this.indentLevel--;
        this.popQueue();
        return declares.join('');
    };
    Visitor.prototype.getHositDeclares = function () {
        var declares = [];
        var hoistDeclares = this.hoistDeclares;
        for (var i = 0; i < hoistDeclares.length; i++) {
            var _a = hoistDeclares[i], key = _a[0], code = _a[1];
            declares.push("var ".concat(key, " = ").concat(code.join(''), ";\n"));
        }
        return declares.join('');
    };
    Visitor.prototype.visit = function (nodes, isRoot) {
        var length = nodes.length;
        var lastIndex = length - 1;
        this.expressionSpacesStack.push(this.spaces);
        var oldLength = this.spacesStatck.length;
        for (var i = 0; i < nodes.length; i++) {
            // if is root, add `return` keyword
            if (isRoot && i === lastIndex) {
                this.append('return ');
            }
            this.visitNode(nodes[i], isRoot, true);
        }
        var newLength = this.spacesStatck.length;
        this.expressionSpacesStack.pop();
        while (newLength > oldLength) {
            this.popSpaces();
            newLength--;
        }
    };
    Visitor.prototype.visitNode = function (node, isRoot, textToVNode) {
        var type = node.type;
        switch (type) {
            case 3 /* JSXCommonElement */:
            case 4 /* JSXComponent */:
            case 7 /* JSXBlock */:
            case 6 /* JSXVdt */:
                return this.visitJSXElement(node, isRoot, textToVNode);
            case 2 /* JSXText */:
                return this.visitJSXText(node, textToVNode);
            case 12 /* JSXString */:
                this.visitString(node, false);
                return;
            case 0 /* JS */:
                this.visitJS(node);
                return;
            case 8 /* JSXExpression */:
                return this.visitJSXExpression(node);
            case 1 /* JSHoist */:
                this.visitJSHoist(node);
                return;
            case 5 /* JSXComment */:
                return this.visitJSXComment(node);
            case 10 /* JSXUnescapeText */:
                return this.visitJSXUnescapeText(node);
            case 13 /* JSXStrings */:
                this.visitStrings(node);
                return;
            case 14 /* JSXNone */:
                this.append('true');
                return;
        }
    };
    Visitor.prototype.visitJS = function (node) {
        // const spaces = this.spaces;
        var stack = this.expressionSpacesStack;
        this.spaces = stack[stack.length - 1];
        var lines = node.value;
        var length = lines.length;
        for (var i = 0; i < length; i++) {
            var code = lines[i];
            this.append(code);
            if (i !== length - 1) {
                this.newline();
            }
        }
        // this.spaces = spaces;
        this.pushSpaces(node.spaces);
    };
    Visitor.prototype.visitJSHoist = function (node) {
        this.hoist.push(node.value);
    };
    Visitor.prototype.visitJSXElement = function (node, isRoot, textToVNode) {
        var _this = this;
        return this.visitJSXDirective(node, function (hasFor) {
            switch (node.type) {
                case 3 /* JSXCommonElement */:
                    if (node.value === 'template') {
                        // <template> is a fake tag, we only need handle its children and directives
                        return _this.visitJSXChildren(node.children, hasFor ? true : textToVNode);
                    }
                    return _this.visitJSXCommonElement(node);
                case 4 /* JSXComponent */:
                    return _this.visitJSXComponent(node);
                case 7 /* JSXBlock */:
                    return _this.visitJSXBlock(node, true);
                case 6 /* JSXVdt */:
                    return _this.visitJSXVdt(node, isRoot);
            }
        });
    };
    Visitor.prototype.visitJSXCommonElement = function (node) {
        var tag = node.value;
        if (this.hasExpressionProp(node.attributes)) {
            this.addHelper('_$cv');
            this.append("_$cv('".concat(tag, "', "));
            var _a = this.visitJSXAttribute(node, false), key_1 = _a.key; _a.hasProps;
            if (node.children.length) {
                this.append(', ');
                this.visitJSXChildren(node.children);
            }
            this.append(')');
            return key_1 ? 2 /* HasKeyedVNodeChildren */ : 4 /* HasNonKeyedVNodeChildren */;
        }
        this.addHelper('_$ce');
        this.append("_$ce(".concat(getTypeForVNodeElement(tag), ", '").concat(tag, "'"));
        this.pushQueue();
        this.append(', ');
        var childrenFlag = this.visitJSXChildren(node.children);
        this.append(", ".concat(childrenFlagToChildrenType(childrenFlag)));
        if (childrenFlag !== 1 /* HasInvalidChildren */) {
            this.flush(this.popQueue());
            this.pushQueue();
        }
        var propsQueue = this.pushQueue();
        this.append(', ');
        var _b = this.visitJSXAttribute(node, true), className = _b.className, key = _b.key, ref = _b.ref, hasProps = _b.hasProps;
        this.popQueue();
        this.append(', ');
        if (className) {
            this.flush(this.popQueue());
            this.visitJSXAttributeClassName(className);
            this.pushQueue();
        }
        else {
            this.append('null');
        }
        this.flush(propsQueue);
        var ret = this.visitProps(hasProps, key, ref, false);
        this.append(')');
        return ret;
    };
    Visitor.prototype.visitJSXComponent = function (node) {
        var name = node.value;
        // switch (name) {
        // case 'Transition':
        // name = '_$tr';
        // this.addHelper(name as '_$tr');
        // break;
        // case 'TransitionGroup':
        // name = '_$tg';
        // this.addHelper(name as '_$tg');
        // break;
        // default:
        // break;
        // } 
        var blocks = this.getJSXBlocksAndSetChildren(node);
        if (blocks.length) {
            node.attributes.push({
                type: 11 /* JSXAttribute */,
                name: '$blocks',
                value: blocks,
                loc: fakeLoc,
            });
        }
        this.addHelper('_$cc');
        this.append("_$cc(".concat(name));
        this.pushQueue();
        this.append(', ');
        var _a = this.visitJSXAttribute(node, false), key = _a.key, ref = _a.ref, hasProps = _a.hasProps;
        var ret = this.visitProps(hasProps, key, ref, true);
        this.append(')');
        return ret;
    };
    Visitor.prototype.visitJSXExpression = function (node) {
        var value = node.value;
        if (!value.length) {
            this.append('null');
            return 1 /* HasInvalidChildren */;
        }
        else {
            this.visit(value, false);
            return 0 /* UnknownChildren */;
        }
    };
    Visitor.prototype.visitJSXText = function (node, textToVNode) {
        if (textToVNode) {
            this.addHelper('_$ct');
            this.append('_$ct(');
            this.visitString(node, false);
            this.append(')');
            return 4 /* HasNonKeyedVNodeChildren */;
        }
        this.visitString(node, false);
        return 32 /* HasTextChildren */;
    };
    Visitor.prototype.visitStrings = function (node) {
        var value = node.value;
        var lastIndex = value.length - 1;
        for (var i = 0; i <= lastIndex; i++) {
            this.visitNode(value[i], false, false);
            if (i !== lastIndex) {
                this.append(' + ');
            }
        }
    };
    Visitor.prototype.visitJSXUnescapeText = function (node) {
        this.addHelper('_$cu');
        this.append('_$cu(');
        this.visit(node.value, false);
        this.append(')');
        return 4 /* HasNonKeyedVNodeChildren */;
    };
    Visitor.prototype.visitJSXBlock = function (node, shouldCall) {
        var _a = this.getJSXBlocksAttribute(node), params = _a.params, args = _a.args;
        var name = node.value;
        if (shouldCall) {
            this.addDeclare('_$blocks', '{}');
            this.addDeclare('__$blocks', '{}');
        }
        this.append('(');
        this.indent();
        this.append("(_$blocks['".concat(name, "'] = function($super"));
        if (args) {
            this.append(', ');
            this.visitString(args, true);
        }
        this.append(') {');
        this.indent();
        this.append('return ');
        this.visitJSXChildren(node.children);
        this.append(';');
        this.dedent();
        this.append("}),");
        this.newline();
        this.append("(__$blocks['".concat(name, "'] = function($super, data) {"));
        this.indent();
        this.append("var block = $blocks['".concat(name, "'];"));
        this.newline();
        this.append("var callBlock = function() {");
        this.indent();
        this.append("return _$blocks['".concat(name, "'].call($this, $super, data);"));
        this.dedent();
        this.append('};');
        this.newline();
        this.append("return block ?");
        this.indent();
        this.append("block.call($this, callBlock, data) :");
        this.newline();
        this.append("callBlock();");
        this.indentLevel--;
        this.dedent();
        this.append('})');
        // if it is in ancestor, we should call this block
        if (shouldCall) {
            this.append(',');
            this.newline();
            this.addHelper('_$no');
            if (params) {
                this.append("__$blocks['".concat(name, "'](_$no, "));
                this.visitJSXAttributeValue(params);
                this.append(')');
            }
            else {
                this.append("__$blocks['".concat(name, "'](_$no)"));
            }
        }
        this.dedent();
        this.append(')');
        return 0 /* UnknownChildren */;
    };
    Visitor.prototype.visitJSXVdt = function (node, isRoot) {
        var blocks = this.getJSXBlocksAndSetChildren(node);
        var name = node.value;
        if (name === 'super') {
            name = '_$su';
            this.addHelper(name);
        }
        this.append("".concat(name, ".call($this, "));
        this.visitJSXAttribute(node, false);
        this.append(", ");
        if (blocks.length) {
            this.visitJSXBlocks(blocks, isRoot);
        }
        else {
            this.append(isRoot ? '$blocks' : 'null');
        }
        this.append(', $__proto__)');
        return 0 /* UnknownChildren */;
    };
    Visitor.prototype.visitJSXComment = function (node) {
        this.addHelper('_$ccv');
        this.append('_$ccv(');
        this.visitString(node, false);
        this.append(')');
        return 4 /* HasNonKeyedVNodeChildren */;
    };
    Visitor.prototype.visitString = function (node, noQuotes) {
        var value = node.value.replace(/([\'\"\\])/g, '\\$1').replace(/[\r\n]/g, '\\n');
        if (!noQuotes) {
            value = "'".concat(value, "'");
        }
        this.append(value);
    };
    Visitor.prototype.visitJSXDirective = function (node, body) {
        var _this = this;
        var directiveFor = {};
        var directiveIf = null;
        var directives = node.directives;
        for (var key in directives) {
            var directive = directives[key];
            switch (key) {
                case "v-if" /* If */:
                    directiveIf = directive;
                    break;
                case "v-for" /* For */:
                    directiveFor.data = directive.value;
                    break;
                case "v-for-value" /* ForValue */:
                    directiveFor.value = directive.value;
                    break;
                case "v-for-key" /* ForKey */:
                    directiveFor.key = directive.value;
                    break;
            }
        }
        // handle v-for firstly
        if (directiveFor.data) {
            if (directiveIf) {
                return this.visitJSXDirectiveFor(directiveFor, function () {
                    return _this.visitJSXDirectiveIf(directiveIf, function () { return body(true); });
                });
            }
            else {
                return this.visitJSXDirectiveFor(directiveFor, function () { return body(true); });
            }
        }
        else if (directiveIf) {
            return this.visitJSXDirectiveIf(directiveIf, function () { return body(false); });
        }
        else {
            return body(false);
        }
    };
    Visitor.prototype.visitJSXDirectiveFor = function (directive, body) {
        this.addHelper('_$ma');
        this.append('_$ma(');
        this.visitJSXAttributeValue(directive.data);
        this.append(', function(');
        if (directive.value) {
            this.visitString(directive.value, true);
        }
        else {
            this.append('$value');
        }
        this.append(', ');
        if (directive.key) {
            this.visitString(directive.key, true);
        }
        else {
            this.append('$key');
        }
        this.append(') {');
        this.indent();
        this.append('return ');
        var childrenFlag = body();
        this.append(';');
        this.dedent();
        this.append('}, $this)');
        if (childrenFlag & 10 /* KeydChildren */) {
            return 8 /* HasKeyedChildren */;
        }
        else if (childrenFlag === 0 /* UnknownChildren */) {
            return childrenFlag;
        }
        return 16 /* HasNonKeyedChildren */;
    };
    Visitor.prototype.visitJSXDirectiveIf = function (directive, body) {
        var indentLevel = this.indentLevel;
        var hasElse = false;
        this.append('(');
        this.visitJSXAttributeValue(directive.value);
        this.append(')');
        this.append(' ?');
        this.indent();
        var childrenFlag = body();
        this.append(' :');
        this.newline();
        var next = directive.next;
        while (next) {
            var nextDirectives = next.directives;
            var elseIfDir = nextDirectives["v-else-if" /* ElseIf */];
            if (elseIfDir) {
                this.visitJSXAttributeValue(elseIfDir.value);
                this.append(' ?');
                this.indent();
                childrenFlag = computeChildrenFlagForVIf(childrenFlag, this.visitNode(next, false, false));
                this.append(' :');
                this.newline();
                next = elseIfDir.next;
                continue;
            }
            else {
                // should be Directives.Else
                childrenFlag = computeChildrenFlagForVIf(childrenFlag, this.visitNode(next, false, false));
                hasElse = true;
            }
            break;
        }
        if (!hasElse) {
            this.append('undefined');
            childrenFlag = computeChildrenFlagForVIf(childrenFlag, 1 /* HasInvalidChildren */);
        }
        this.indentLevel = indentLevel;
        return childrenFlag;
    };
    Visitor.prototype.visitJSXChildren = function (nodes, textToVNode) {
        var length = nodes.length;
        if (!length) {
            this.append('null');
            return 1 /* HasInvalidChildren */;
        }
        var childrenFlag = null;
        if (length === 1) {
            var child = nodes[0];
            var hasIndent = false;
            if (isElementNode(child)) {
                hasIndent = true;
                this.append('(');
                this.indent();
            }
            childrenFlag = this.visitNode(child, false, isUndefined(textToVNode) ? false : textToVNode);
            if (hasIndent) {
                this.dedent();
                this.append(')');
            }
        }
        else {
            this.append('[');
            this.indent();
            var lastIndex = nodes.length - 1;
            for (var i = 0; i < nodes.length; i++) {
                var child = nodes[i];
                child.type;
                var flag = this.visitNode(child, false, true);
                childrenFlag = computeChildrenFlagForChildren(childrenFlag, flag);
                if (i !== lastIndex) {
                    this.append(',');
                    this.newline();
                }
            }
            this.dedent();
            this.append(']');
            if (childrenFlag === 2 /* HasKeyedVNodeChildren */) {
                childrenFlag = 8 /* HasKeyedChildren */;
            }
            else if (childrenFlag === 4 /* HasNonKeyedVNodeChildren */) {
                childrenFlag = 16 /* HasNonKeyedChildren */;
            }
        }
        return childrenFlag;
    };
    Visitor.prototype.visitJSXAttribute = function (node, isCommonElement) {
        var _this = this;
        var attributes = node.attributes;
        var className = null;
        var key = null;
        var ref = null;
        if (!attributes.length) {
            this.append('null');
            return { className: className, key: key, ref: ref, hasProps: false };
        }
        // use a queue to save props, so we can extract it when there isn't dynamic prop
        var propsQueue = this.pushQueue();
        // const isCommonElement = node.type === ASTTypes.JSXCommonElement;
        var modelMeta = {};
        var models = [];
        var hasDynamicProp = this.hasDynamicProp(attributes, isCommonElement);
        var indentLevel = this.indentLevel;
        var spaces = this.spaces;
        if (!hasDynamicProp) {
            this.indentLevel = 0;
            this.spaces = '';
        }
        var isFirstAttr = true;
        var addAttribute = function (name) {
            if (isFirstAttr) {
                _this.append('{');
                _this.indent();
                isFirstAttr = false;
            }
            else {
                _this.append(',');
                _this.newline();
            }
            if (name) {
                _this.append("'".concat(name, "': "));
            }
        };
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];
            if (attr.type === 8 /* JSXExpression */) {
                addAttribute();
                this.visitJSXAttributeValue(attr);
                continue;
            }
            var name_1 = getAttrName(attr.name);
            var value = attr.value;
            switch (name_1) {
                case 'className':
                    if (!isCommonElement) {
                        addAttribute(name_1);
                        this.visitJSXAttributeClassName(value);
                    }
                    className = value;
                    continue;
                case 'key':
                    if (!isCommonElement) {
                        addAttribute(name_1);
                        this.visitJSXAttributeValue(value);
                    }
                    key = value;
                    continue;
                case 'ref':
                    if (!isCommonElement) {
                        addAttribute(name_1);
                        this.visitJSXAttributeRef(value, true);
                    }
                    ref = value;
                    continue;
                case '$blocks':
                    addAttribute(name_1);
                    this.visitJSXBlocks(value, false);
                    continue;
                case 'type':
                    // save the type for v-model of input element
                    addAttribute(name_1);
                    this.visitJSXAttributeValue(value);
                    modelMeta.type = value;
                    continue;
                case 'value':
                    addAttribute(name_1);
                    this.visitJSXAttributeValue(value);
                    modelMeta.value = value;
                    break;
                case 'v-model-true':
                    addAttribute('trueValue');
                    this.visitJSXAttributeValue(value);
                    modelMeta.trueValue = value;
                    break;
                case 'v-model-false':
                    addAttribute('falseValue');
                    this.visitJSXAttributeValue(value);
                    modelMeta.falseValue = value;
                    break;
                default:
                    if (name_1 === 'v-model') {
                        models.push({ name: 'value', value: value });
                        continue;
                    }
                    else if (name_1.substr(0, 8) === 'v-model:') {
                        models.push({ name: name_1.substr(8), value: value });
                        continue;
                    }
                    else {
                        addAttribute(name_1);
                        this.visitJSXAttributeValue(value);
                    }
                    break;
            }
        }
        for (var i = 0; i < models.length; i++) {
            this.visitJSXAttributeModel(node, models[i], modelMeta, addAttribute);
        }
        if (!isFirstAttr) {
            this.dedent();
            this.append('}');
        }
        else {
            this.append('null');
        }
        this.indentLevel = indentLevel;
        this.spaces = spaces;
        this.popQueue();
        if (isFirstAttr || hasDynamicProp) {
            this.flush(propsQueue);
        }
        else {
            this.append(this.addHoistDeclare(propsQueue));
        }
        return { className: className, key: key, ref: ref, hasProps: !isFirstAttr };
    };
    Visitor.prototype.hasExpressionProp = function (attributes) {
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];
            if (attr.type === 8 /* JSXExpression */) {
                return true;
            }
        }
        return false;
    };
    Visitor.prototype.hasDynamicProp = function (attributes, isCommonElement) {
        var detect = function (name, attr) {
            if (name === 'v-model' || name.substr(0, 8) === 'v-model:') {
                return true;
            }
            var value = attr.value;
            if (value.type === 8 /* JSXExpression */) {
                // if value is number / true / false, treat it as static value
                var tmp = value.value;
                var length_1 = tmp.length;
                if (!length_1)
                    return false; // is an empty expresion, it will be generated to null
                if (length_1 === 1 &&
                    (tmp = tmp[0], tmp.type === 0 /* JS */) &&
                    (tmp = tmp.value, tmp.length === 1)) {
                    var jsValue = tmp[0];
                    switch (jsValue) {
                        case 'true':
                        case 'false':
                        case 'null':
                        case 'undefined':
                            return false;
                        default:
                            if (numberRegExp.test(jsValue))
                                return false;
                            break;
                    }
                }
                return true;
            }
            if (value.type === 13 /* JSXStrings */) {
                var values = value.value;
                for (var i = 0; i < values.length; i++) {
                    if (values[i].type === 8 /* JSXExpression */) {
                        return true;
                    }
                }
            }
            return false;
        };
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];
            if (attr.type === 8 /* JSXExpression */) {
                return true;
            }
            var name_2 = attr.name;
            switch (name_2) {
                case 'class':
                case 'className':
                case 'key':
                    if (isCommonElement)
                        continue;
                    if (detect(name_2, attr))
                        return true;
                    break;
                case 'ref':
                    if (!isCommonElement)
                        return true;
                    break;
                case '$blocks':
                case 'children':
                    return true;
                default:
                    if (detect(name_2, attr))
                        return true;
                    break;
            }
        }
        return false;
    };
    Visitor.prototype.visitJSXAttributeClassName = function (value) {
        if (value.type === 8 /* JSXExpression */) {
            this.addHelper('_$cn');
            this.append('_$cn(');
            this.visitJSXAttributeValue(value);
            this.append(')');
        }
        else {
            this.visitJSXAttributeValue(value);
        }
    };
    Visitor.prototype.visitJSXAttributeValue = function (value) {
        if (isArray(value)) {
            this.visitJSXChildren(value);
        }
        else {
            this.visitNode(value, false, false);
        }
    };
    Visitor.prototype.visitJSXAttributeRef = function (value, isComponent) {
        if (value.type === 12 /* JSXString */) {
            this.addDeclare('_$refs', 'this.refs');
            // if it is a component, the ref will use twice, so we extract it as variable
            var indentLevel = void 0;
            var refQueue = void 0;
            if (isComponent) {
                refQueue = this.pushQueue();
                indentLevel = this.indentLevel;
                this.indentLevel = 0;
            }
            this.append("function(i) {_$refs[");
            this.visitJSXAttributeValue(value);
            this.append("] = i}");
            if (isComponent) {
                this.indentLevel = indentLevel;
                this.popQueue();
                this.append(this.addDeclare("_$ref_".concat(value.value), refQueue));
            }
        }
        else {
            this.visit(value.value, false);
        }
    };
    Visitor.prototype.visitJSXAttributeModel = function (node, _a, modelMeta, addAttribute) {
        var _this = this;
        var name = _a.name, value = _a.value;
        var shouldSetValue = true;
        var handleRadioOrCheckbox = function (head, middle, tail, defaultValue) {
            shouldSetValue = false;
            addAttribute('checked');
            _this.append(head);
            _this.visitJSXAttributeValue(value);
            _this.append(middle);
            if (tail) {
                _this.visitJSXAttributeValue(tail);
            }
            else {
                _this.append(defaultValue);
            }
        };
        if (node.type === 3 /* JSXCommonElement */) {
            var setModelFnName = '_$stm';
            var eventName = 'change';
            addAttribute("$model:".concat(name));
            this.visitJSXAttributeValue(value);
            switch (node.value) {
                case 'input':
                    var type = modelMeta.type;
                    if (type) {
                        switch (type.value) {
                            case 'radio':
                                handleRadioOrCheckbox('$this.get(', ') === ', modelMeta.value, "'on'");
                                setModelFnName = '_$srm';
                                break;
                            case 'checkbox':
                                this.addHelper('_$isc');
                                handleRadioOrCheckbox('_$isc($this.get(', '), ', modelMeta.trueValue, 'true');
                                this.append(')');
                                setModelFnName = '_$scm';
                                break;
                            // case 'number':
                            // TODO: shoud cast to number
                            default:
                                eventName = 'input';
                                break;
                        }
                    }
                    else {
                        eventName = 'input';
                    }
                    break;
                case 'select':
                    setModelFnName = '_$ssm';
                    break;
                default:
                    eventName = 'input';
                    break;
            }
            addAttribute("ev-$model:".concat(eventName));
            this.addHelper('_$le');
            this.addHelper(setModelFnName);
            this.append("_$le($this, ".concat(setModelFnName, ")"));
        }
        else {
            // is a component
            addAttribute("ev-$model:".concat(name));
            this.append("function($v) {");
            this.indent();
            this.append("$this.set(");
            this.visitJSXAttributeValue(value);
            this.append(', $v);');
            this.dedent();
            this.append('}');
        }
        if (shouldSetValue) {
            addAttribute(name);
            this.append('$this.get('),
                this.visitJSXAttributeValue(value);
            this.append(')');
        }
    };
    Visitor.prototype.visitJSXBlocks = function (blocks, isRoot) {
        this.addHelper('_$ex');
        this.addHelper('_$em');
        this.append('function($blocks) {');
        this.indent();
        this.append("var _$blocks = {}, __$blocks = _$ex({}, $blocks);");
        this.newline();
        this.append('return (');
        this.indent();
        for (var i = 0; i < blocks.length; i++) {
            this.visitJSXBlock(blocks[i], false);
            this.append(',');
            this.newline();
        }
        this.append('__$blocks');
        this.dedent();
        this.append(');');
        this.dedent();
        this.append("}.call($this, ".concat(isRoot ? '$blocks' : '_$em', ")"));
    };
    Visitor.prototype.getJSXBlocksAndSetChildren = function (node) {
        var blocks = [];
        var children = [];
        var nodeChildren = node.children;
        for (var i = 0; i < nodeChildren.length; i++) {
            var child = nodeChildren[i];
            if (child.type === 7 /* JSXBlock */) {
                blocks.push(child);
            }
            else {
                children.push(child);
            }
        }
        if (children.length) {
            node.attributes.push({
                type: 11 /* JSXAttribute */,
                name: 'children',
                value: children,
                loc: fakeLoc,
            });
        }
        return blocks;
    };
    Visitor.prototype.getJSXBlocksAttribute = function (node) {
        var ret = { args: null, params: null };
        var attributes = node.attributes;
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];
            switch (attr.name) {
                case 'args':
                    ret.args = attr.value;
                    break;
                case 'params':
                    ret.params = attr.value;
                    break;
            }
        }
        return ret;
    };
    Visitor.prototype.visitProps = function (hasProps, key, ref, isComponent) {
        var childrenFlag = 4 /* HasNonKeyedVNodeChildren */;
        if (hasProps) {
            this.flush(this.popQueue());
            this.pushQueue();
        }
        this.append(', ');
        if (key) {
            this.flush(this.popQueue());
            this.visitJSXAttributeValue(key);
            this.pushQueue();
            childrenFlag = 2 /* HasKeyedVNodeChildren */;
        }
        else {
            this.append('null');
        }
        this.append(', ');
        if (ref) {
            this.flush(this.popQueue());
            this.visitJSXAttributeRef(ref, isComponent);
            this.pushQueue();
        }
        else {
            this.append('null');
        }
        this.popQueue();
        return childrenFlag;
    };
    Visitor.prototype.append = function (code) {
        this.current.push(code);
        // if (true [> sourceMap <]) {
        // TODO 
        // }
    };
    Visitor.prototype.addHelper = function (helper) {
        this.helpers[helper] = true;
    };
    Visitor.prototype.addHoistDeclare = function (code) {
        var key = "_$tmp".concat(this.tmpIndex++);
        this.hoistDeclares.push([key, code]);
        return key;
    };
    Visitor.prototype.addDeclare = function (key, code) {
        this.declares[key] = code;
        return key;
    };
    Visitor.prototype.pushQueue = function () {
        this.current = [];
        this.queueStack.push(this.current);
        return this.current;
    };
    Visitor.prototype.popQueue = function () {
        var stack = this.queueStack;
        var queue = stack.pop();
        this.current = stack[stack.length - 1];
        return queue;
    };
    Visitor.prototype.flush = function (queue) {
        for (var i = 0; i < queue.length; i++) {
            this.append(queue[i]);
        }
    };
    Visitor.prototype.indent = function () {
        this.indentLevel++;
        this.newline();
    };
    Visitor.prototype.dedent = function () {
        this.indentLevel--;
        this.newline();
    };
    Visitor.prototype.newline = function () {
        this.append('\n' + "    ".repeat(this.indentLevel) + this.spaces);
    };
    Visitor.prototype.pushSpaces = function (spaces) {
        if (spaces) {
            this.spaces += ' '.repeat(spaces);
        }
        this.spacesStatck.push(this.spaces);
    };
    Visitor.prototype.popSpaces = function () {
        var stack = this.spacesStatck;
        stack.pop();
        this.spaces = stack[stack.length - 1];
    };
    return Visitor;
}());

export { Parser, Visitor };
